<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <div class="info_form">
      <el-form ref="form" :model="form" :label-width="labelWidth" :rules="rules" :inline="true">
        <div class="block">
          <!-- 标题 -->
          <div class="contit">基础信息</div>
          <FormItem v-for="(c, i) in formCtrl" :key="'formItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
        </div>

        <div class="block">
          <div class="contit">装货信息</div>
          <FormItem v-for="(c, i) in formCtrlIn" :key="'formItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
        </div>

        <div class="block">
          <div class="contit">卸货信息</div>
          <FormItem v-for="(c, i) in formCtrlOut" :key="'formItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
        </div>

        <div class="block">
          <div class="contit">运单信息</div>

          <FormItem v-for="(c, i) in formCtrlOrder.slice(0, 3)" :key="'formItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />

          <div v-show="form.pricing != 5">
            <FormItem v-for="(c, i) in formCtrlOrder.slice(3)" :key="'formItem' + i" :viewMode="c.viewMode" :config="c"
              :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />

            <!-- 亏吨重量控件 -->
            <span>
              <FormItem v-show="form.pricing == 1" :viewMode="kuitonCtrl.viewMode" :config="kuitonCtrl"
                :options="kuitonCtrl.options" :inputValue="form[kuitonCtrl.keyName]" @onChange="onChange" />
            </span>
          </div>

          <!-- 装/卸货单 -->
          <div>
            <FormItem v-for="(c, i) in formCtrlOrder2" :key="'formO2Item' + i" :viewMode="c.viewMode" :config="c"
              :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
          </div>
          <!-- 其他重量控件 -->
          <div v-show="form.pricing == 1">
            <FormItem v-for="(c, i) in formCtrlWeight" :key="'formItemWeight' + i" :viewMode="c.viewMode" :config="c"
              :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
          </div>

          <FormItem v-for="(c, i) in formCtrl2" :key="'form2Item' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange">
            <template #end>
              <PaymentSwitch v-show="form['repaytime']" :value="form['istime']" @onToggle="onToggle" />
            </template>
          </FormItem>

          <!-- 可变文本域备注 -->
          <FormItem v-for="(c, i) in formCtrl3" :key="'form3Item' + i" :ref="'form3Item' + i" :viewMode="c.viewMode"
            :config="c" :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" @onInput="onInput">
          </FormItem>
        </div>

        <ExtraFee :form="form" :formCtrl="formCtrlfee" @onChange="onChange" />
      </el-form>
    </div>

    <div class="btns">
      <el-button v-if="showRejectBtn" type="primary" class="reject" @click="onRejectSubmit">
        驳回修改
      </el-button>
      <el-button v-if="showExamineBtn" type="primary" class="examine" @click="updateStatus">
        审核通过
      </el-button>
      <SubmitBtn v-if="!viewMode" :editMode="true" @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";
import nonOrderViewMixin from "./nonOrderViewMixin";

export default {
  mixins: [detailMixin, nonOrderViewMixin],
  data() {
    return {
      baseUrl: 'order',
      breadcrumb: [
        { name: "运单管理", path: "/order/nocontract" },
        { name: "运单列表", path: "/order/nocontract/own/uncheck" },
        { name: "运单添加" },
      ],
    };
  },
  computed: {
    // 是否显示驳回按钮
    showRejectBtn() {
      let boo = false
      // console.log('detail', { ...this.detail })
      if (this.detail.isstatus != 3) return boo
      if (this.user && this.detail.isfleet == 2) {
        if ([2, 3, 4].includes(this.user.user_group_id)) {
          boo = true
        }
      }
      return boo
    },
    // 是否显示审核按钮
    showExamineBtn() {
      let boo = false
      // console.log('detail', { ...this.detail })
      if (this.detail.isstatus != 3) return boo
      if (this.user && this.detail.isfleet == 2) {
        if ([2, 3, 4].includes(this.user.user_group_id)) {
          boo = true
        }
      }
      return boo
    },
  },
  methods: {
    onRejectSubmit() {
      // console.log({ ...this.form });
      // console.log(this.$refs['form']);
      this.$prompt('', '驳回原因', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(({ value }) => {
        this.rejectReq(value);
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // });
      });
    },
    rejectReq(reject_reason) {
      this.loading = true
      let url = `order/reject`;
      const params = {
        id: this.id,
        userid: this.user.id,
        reject_reason
      }
      this.post(url, params, ({
        msg
      }) => {
        this.loading = false
        if (msg == 'success') {
          this.$message({
            type: 'success',
            message: '驳回成功!',
          });
          this.$router.back()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '驳回失败，请稍后重试！'
        });
      })
    },
  },
  created() {
    this.formCtrlWeight.splice(0, 0, {
      label: "计算量",
      keyName: "caton",
      err: "请填写计算量",
      type: "number",
    })
  },
  mounted() { },
};
</script>

<style lang="less" scoped>
.info_form {
  background-color: #fff;
  padding-top: 20px;
  padding-bottom: 5px;
  border-radius: 5px;

  .contit {
    height: 24px;
    line-height: 24px;
    overflow: hidden;
    margin: 0 auto 25px;
    padding: 0 21px;
    font-weight: bold;
    font-size: 18px;
    color: #343434;
  }

  /deep/ .el-form {
    margin-bottom: 20px;

    .el-form-item {
      padding: 0 20px 0 0;
      margin-bottom: 20px;

      &.view {
        .el-form-item__label {
          padding: 0;
        }
      }

      &.first {
        .el-form-item__content {
          width: 300px;
        }
      }

      &.unton {
        width: 1000px;
      }

      &.block {
        width: 100%;
        padding-right: 0;
        margin-right: 0;
      }

      .el-input,
      .el-date-editor--daterange {
        width: 300px;
      }

      .el-form-item__content {
        .el-input {
          width: 300px;
        }

        .unit {
          color: #909399;
        }

        .switch {
          margin-left: 10px;

          .el-switch {
            display: block;

            .el-switch__core {
              margin: 2px auto;
              display: block;
            }

            &.inactive {
              .el-switch__core::after {
                content: '关';
                line-height: 17px;
                text-indent: 18px;
                color: #fff;
              }
            }

            &.active {
              .el-switch__core::after {
                content: '开';
                line-height: 17px;
                text-indent: -16px;
                color: #fff;
              }
            }
          }

          .txt {
            min-width: 50px;
            line-height: 16px;
            font-size: 12px;
            color: #909399;
            margin-top: 3px;
          }
        }
      }

    }
  }

  .el-form:last-child {
    margin-bottom: 0;
  }
}

.btns {
  margin: 40px 0 60px 180px;

  .reject {
    background: #FF4541;
    border-color: #FF4541;
  }

  .examine {
    background: #0fc4b1;
    border-color: #0fc4b1;
  }
}

.el-form-items {
  .tit_label {
    display: flex;

    .title {
      margin-left: 40px;
      cursor: pointer;
    }
  }

}

.tit_label {
  margin: 19px 0 17px 25px;
  font-weight: bold;
  font-size: 18px;
  color: #343434;
}

/deep/ .el-collapse-item__header {
  margin: 17px 0 18px 112px;
  text-align: left;
  font-size: 18px;
  color: #333;
}

/deep/.el-collapse-item__arrow {
  display: none;
}

.el-form-item__content {
  margin-left: 0 !important;
}

/deep/ .el-collapse-item__content {
  padding-bottom: 0 !important;
}

/deep/ .el-textarea__inner {
  font-family: "Microsoft Yahei";
}
</style>
